module.exports = __webpack_public_path__ + "static/img/k11.70e1ba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/k11.jpg
// module id = SszP
// module chunks = 0